const border = {
  sm: '4px',
  full: '10000px',
  none: '0px'
}

export type BorderProps = typeof border
export default border
